{
  "title": "Benutzer",
  "list_title": "Benutzer",
  "subtitle": "Wer kann sich anmelden — Admins verwalten Konten und Rollen",
  "no_users": "Keine Benutzer",
  "you_marker": "(du)",
  "role": {
    "admin": "Admin",
    "user": "Benutzer"
  },
  "fields": {
    "username": "Benutzername",
    "password": "Passwort",
    "role": "Rolle"
  },
  "actions": {
    "new": "Neuer Benutzer",
    "edit": "Bearbeiten",
    "change_password": "Passwort ändern",
    "delete": "Löschen",
    "delete_confirm": "Benutzer \"{{name}}\" wirklich löschen?\n\nInkl. aller zugewiesenen Agents."
  },
  "errors": {
    "self_delete": "Du kannst dich nicht selbst löschen.",
    "username_exists": "Benutzername existiert bereits."
  },
  "new_dialog": {
    "title": "Neuen Benutzer anlegen",
    "username_placeholder": "z.B. alice"
  },
  "password_dialog": {
    "title": "Passwort ändern: {{name}}",
    "new_password_label": "Neues Passwort",
    "min_length_hint": "Mindestens 8 Zeichen"
  },
  "edit_dialog": {
    "title": "Benutzer bearbeiten: {{name}}"
  },
  "apikeys": {
    "title": "API-Keys",
    "subtitle": "Langlebige Tokens für externe Zugriffe (MCP, Skripte) — kein Login nötig",
    "name_placeholder": "z.B. claude-code-local",
    "create": "Key erzeugen",
    "save_now": "Speichere diesen Key jetzt — er wird nur einmal angezeigt:",
    "copy": "Kopieren",
    "copied": "Kopiert!",
    "dismiss": "Schließen",
    "delete_confirm": "API-Key wirklich widerrufen?",
    "empty": "Noch keine API-Keys angelegt.",
    "own_title": "Meine API-Keys",
    "own_subtitle": "Für Skripte, Apps und Zugangsdaten-Profile deiner Agenten. Ein Key hat deine Rechte, gib ihn nicht weiter. Anlegen und Löschen geht nur hier mit deiner Anmeldung.",
    "loading": "API-Keys werden geladen …"
  }
}
